const isMobile = () => {
  const {innerWidth: width} = window;

  return width < 768;
};

export default isMobile;
